import { useEffect, useMemo, useState } from "react";

export const usePassRequire = (
  email = "",
  password: string,
  repeatPassword: string
) => {
  const [isSamePass, setIsSamePass] = useState<boolean | null>(null);
  const [isNotEqual, setIsNotEqual] = useState<boolean | null>(null);
  const [isMinLength, setIsMinLength] = useState<boolean | null>(null);
  const [isHaveLower, setIsHaveLower] = useState<boolean | null>(null);
  const [isHaveUpper, setIsHaveUpper] = useState<boolean | null>(null);
  const [isHaveNumber, setIsHaveNumber] = useState<boolean | null>(null);
  const [isHaveSpecial, setIsHaveSpecial] = useState<boolean | null>(null);

  useEffect(() => {
    if (!password) {
      setIsSamePass(null);
      setIsNotEqual(null);
      setIsMinLength(null);
      setIsHaveLower(null);
      setIsHaveUpper(null);
      setIsHaveNumber(null);
      setIsHaveSpecial(null);
    } else {
      if (password.toLocaleLowerCase() !== email.toLocaleLowerCase()) {
        setIsNotEqual(true);
      } else {
        setIsNotEqual(false);
      }

      if (password.length >= 6) {
        setIsMinLength(true);
      } else {
        setIsMinLength(false);
      }

      if (password.match(/[A-Z]/)) {
        setIsHaveUpper(true);
      } else {
        setIsHaveUpper(false);
      }

      if (password.match(/[a-z]/)) {
        setIsHaveLower(true);
      } else {
        setIsHaveLower(false);
      }

      if (password.match(/\d/)) {
        setIsHaveNumber(true);
      } else {
        setIsHaveNumber(false);
      }

      if (password.match(/[^A-Za-z0-9]/)) {
        setIsHaveSpecial(true);
      } else {
        setIsHaveSpecial(false);
      }
      if (password === repeatPassword) {
        setIsSamePass(true);
      } else {
        setIsSamePass(false);
      }
    }
  }, [email, password, repeatPassword]);

  const validPass = useMemo(
    () =>
      isNotEqual &&
      isMinLength &&
      isHaveLower &&
      isHaveUpper &&
      isHaveNumber &&
      isHaveSpecial,
    [
      isNotEqual,
      isMinLength,
      isHaveLower,
      isHaveUpper,
      isHaveNumber,
      isHaveSpecial,
    ]
  );

  return {
    isSamePass,
    isNotEqual,
    isMinLength,
    isHaveLower,
    isHaveUpper,
    isHaveNumber,
    isHaveSpecial,
    validPass,
  };
};
